/** @format */

// login
export const LOGIN_ADMIN = "LOGIN_ADMIN";

//LogOut_admin
export const LOGOUT_ADMIN = "LOGOUT_ADMIN";

// OTP login steps
export const LOGIN_STEP1_SUCCESS = "LOGIN_STEP1_SUCCESS";
export const LOGIN_VERIFY_OTP_SUCCESS = "LOGIN_VERIFY_OTP_SUCCESS";

// get profile
export const PROFILE_ADMIN = "PROFILE_ADMIN";

//  admin profile update
export const UPDATE_PROFILE = "UPDATE_PROFILE";

// Change Password
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

// Update Image Profile
export const UPDATE_IMAGE_PROFILE = "UPDATE_IMAGE_PROFILE";

//Update Password
export const UPDATE_ADMIN_PASSWORD = "UPDATE_ADMIN_PASSWORD";

export const SIGNUP_ADMIN = "SIGNUP_ADMIN";

// admin users management
export const GET_ALL_ADMINS = "GET_ALL_ADMINS";
export const TOGGLE_ADMIN_DISABLE = "TOGGLE_ADMIN_DISABLE";
